export default{"initial.caption.caption":()=>({"text.appearing":()=>[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:'initial'}]})};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-charts/src/_internal/components/caption/index.animation.js
// module id = SLF5
// module chunks = 1